const { container } = require('@/container');

/**
 * Display a loading overlay over the whole app which blocks interaction and shows a message.
 *
 * @param {string} langKey
 */
const setLoadingMessage = (langKey) => {
    container.$rootScope.setRootProcessingMessage(langKey);
};

/**
 * Hide the loading overlay that blocks interaction with the app.
 */
const clearLoadingMessage = () => {
    container.$rootScope.setRootProcessingMessage();
};

module.exports = {
    setLoadingMessage,
    clearLoadingMessage,
};
